export default function Booking() {
  return (
    <div className="p-10 text-white">
      <h1 className="text-4xl mb-6">Book Service</h1>

      <input placeholder="Your Name" className="block mb-4 p-3 w-full text-black rounded" />
      <input placeholder="Address" className="block mb-4 p-3 w-full text-black rounded" />
      <input placeholder="Date" type="date" className="block mb-4 p-3 w-full text-black rounded" />

      <button className="bg-green-500 px-6 py-3 rounded-xl">
        Confirm Booking
      </button>
    </div>
  );
}